export const getEndorserTitle = (
  appointedEndorser,
  endorserListingType = ''
) => {
  if (endorserListingType === 'ASSIGN' && !appointedEndorser?.user) {
    return '(to be assigned)';
  }
  if (appointedEndorser?.user) {
    return appointedEndorser?.user?.name;
  }
  return `${appointedEndorser?.role?.name}${getFacDept({
    faculty: appointedEndorser?.faculty,
    department: appointedEndorser?.department,
  })}`;
};

const getFacDept = ({ faculty, department }) => {
  if (department) return ` (${department.abbreviation})`;
  if (faculty) return ` (${faculty.abbreviation})`;
  return '';
};

export const getFunding = (data) => {
  if (!data) return null;
  return data.reduce(
    (prev, item) => ({ ...prev, [item.setting.id]: item.setting.title }),
    {}
  );
};
